import $ from 'jquery';
import BaseEvent from './base-event';

export default class TagEvents extends BaseEvent {
    constructor() {
        super({
            event_id: '12',
            category: 'tag',
            action: 'click',
        });

        this.$tagsCont = $('.article-tags-share__tags-block');

        this.init();
    }

    init() {
        this.onTagsClick();
    }

    onTagsClick() {
        this.$tagsCont.find('a').on('click', (e) => {
            this.fireEvent({
                destination_url: e.currentTarget.href,
                label: this.toNormalizedString(e.currentTarget.innerText),
            });
        });
    }
}
